import React from "react";
import PinchZoomPan from "react-responsive-pinch-zoom-pan";



const ImageCropper = ({ imageUrl, x, y, width, height }) => {

  return (
    <PinchZoomPan zoomButtons={false} maxScale={10} position='center'>
      <div>
        <img
          src={imageUrl}
          alt="Cropped"
          style={{
            width: `${width}px`,
            height: `${height}px`,
            objectFit: 'none',
            objectPosition: `-${x}px -${y}px`,
          }}
        />
      </div>
    </PinchZoomPan>
  );
};

export default ImageCropper;